module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic-ext18.47734ae.woff2";